import React, { Component } from "react";
import "./SavingContainer.css";
import { path } from "Constants";
import classNames from "classnames";
import { connect } from "react-redux";
import { resetError, defineScopeLoading, pendingChanges } from "actions/spendActions";
import { UpdateRiseSavingDashboard, GetRiseSavingDetails } from "actions/kpiActions";

class SavingContainer extends Component {
  constructor(props) {
    super(props);

    this.columnsMap = {
      "Purchase Order Compliance": [
        { label: "Purchase Order Spend", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "% Savings", field: "SAVING_VALUE", type: "percent" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Invoice Compliance": [
        { label: "Invoice Spend", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "% Savings", field: "SAVING_VALUE", type: "percent" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Purchase Order Automation": [
        { label: "Purchase Order Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "Saving Per Doc", field: "SAVING_VALUE", type: "currency" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Invoice Automation": [
        { label: "Invoice Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "Saving Per Doc", field: "SAVING_VALUE", type: "currency" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Good Receipt Automation": [
        { label: "Goods Receipt Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "Saving Per Doc", field: "SAVING_VALUE", type: "currency" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Advanced Ship Notice Automation": [
        { label: "ASN Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "Saving Per Doc", field: "SAVING_VALUE", type: "currency" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Improve Strategic Sourcing Savings (Indirect and Direct Spend)": [
        { label: "Improve Strategic Sourcing Saving Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "% Savings", field: "SAVING_VALUE", type: "percent" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Increase Spend Under Management (Indirect and Direct Spend)": [
        { label: "Increase Spend Under Management Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "% Savings", field: "SAVING_VALUE", type: "percent" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Discount Capture - Dynamic Discount Extension of Pre-Negotiated Terms": [
        { label: "Dynamic Discount Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "% Savings", field: "SAVING_VALUE", type: "percent" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
      "Discount Capture - Incremental Discounts": [
        { label: "Incremental Discounts Count", field: "SPEND_COUNT_VAL", type: "number" },
        { label: "% Savings", field: "SAVING_VALUE", type: "percent" },
        { label: "Savings Opportunity", field: "SAVING_OPPORTUNITY", type: "currency" },
        { label: "Capturable Savings", field: "CAPTURABLE_SAVING", type: "currency" },
      ],
    };

    this.state = {
      data: this.initStateFromProps(props.data || []),
      isLoading: false,
      isError: false,
      errorMsg: "",
      isSaveInProgress: false,
      hasChanges: false,
      responseMsg: "",
    };

    this.onSave = this.onSave.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  // --- helpers for parsing API-provided strings like "¥ 3.000000" or "0.5000 %"
  extractSymbolAndNumeric = (val, colType) => {
    if (val === undefined || val === null || String(val).trim() === "") {
      return { symbol: "", numeric: 0 };
    }
    const s = String(val).trim();
    // percent suffix
    if (s.endsWith("%")) {
      const numPart = s.replace("%", "").trim();
      return { symbol: "%", numeric: this.parseNumeric(numPart) };
    }
    // leading non-digit characters as symbol (e.g., "¥ ", "$ ", "HK$ ")
    const leadMatch = s.match(/^([^\d\-\(]+)/);
    if (leadMatch) {
      const symbol = leadMatch[1].trim();
      const numPart = s.replace(leadMatch[1], "").trim();
      return { symbol, numeric: this.parseNumeric(numPart) };
    }
    // otherwise just numeric string
    return { symbol: "", numeric: this.parseNumeric(s) };
  };

  // same parseNumeric logic as your original code but a bit resilient
  parseNumeric = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    if (typeof val === "number") return val;
    let s = String(val).trim();
    if (s === "") return 0;
    // remove common currency and percent characters and spaces/commas
    s = s.replace(/[%$,\s\u00A0]/g, "");
    // remove other currency symbols that can sneak (¥,£,€,₹,₩,₫,₴,₽,₺,₪,฿,٫,٬)
    s = s.replace(/[\u00A3\u00A5\u20AC\u20B9\u20A9\u20AB\u20B4\u20BD\u20BA\u20AA\u0E3F\u066B\u060C]/g, "");
    if (/^\(.+\)$/.test(s)) {
      s = "-" + s.replace(/[()]/g, "");
    }
    const n = Number(s);
    return isNaN(n) ? 0 : n;
  };

  // formatting helpers copied from original file
  formatWithType = (num, type) => {
    if (num === null || num === undefined || num === "") return "";
    const n = typeof num === "number" ? num : this.parseNumeric(num);
    const formatted = n.toLocaleString("en-US", {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
    if (type === "percent") return formatted + "%";
    if (type === "currency") return "$" + formatted; // used only when original API didn't provide symbol — but we prefer API symbol
    return formatted;
  };

  formatTrimmed = (num) => {
    if (num === null || num === undefined || num === "") return "";
    const n = typeof num === "number" ? num : this.parseNumeric(num);
    let s = n.toFixed(4);
    s = s.replace(/\.?0+$/, "");
    return s;
  };

  formatThousandsNoDecimal = (num) => {
    if (num === null || num === undefined || num === "") return "";
    const n = typeof num === "number" ? num : this.parseNumeric(num);
    return n.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  isValidTypingInput = (candidate) => {
    if (candidate === null || candidate === undefined) return false;
    const s = String(candidate).trim();
    if (s === "") return true;
    // remove currency symbols and percent for validation
    const withoutSuffix = s.replace(/[$,%\s\u00A0]/g, "");
    const normalized = /^\(.+\)$/.test(withoutSuffix) ? "-" + withoutSuffix.replace(/[()]/g, "") : withoutSuffix;
    return /^-?(?:\d+|\d*\.\d{0,4})?$/.test(normalized);
  };

  toFourDecimalNumber = (raw) => {
    if (raw === null || raw === undefined || raw === "") return 0;
    const n = this.parseNumeric(raw);
    return Math.round(n * 10000) / 10000;
  };

  // --- Build grouped state from props.data (extract symbols + numeric, keep original formatting for display)
  initStateFromProps = (rows = []) => {
    const grouped = {};
    (rows || []).forEach((r) => {
      const header = r.HEADER_FIELD_NAME || "(No Header)";
      if (!grouped[header]) grouped[header] = [];

      const row = { ...r };
      row.__rawValues = {}; // string shown in UI (includes symbol where applicable)
      row.__symbols = {}; // stores extracted symbol or "%" for each field

      const columns = this.columnsMap[header] || [];
      columns.forEach((col) => {
        const rawVal = row[col.field];
        if (rawVal === undefined || rawVal === null || String(rawVal).trim() === "") {
          // empty
          row.__rawValues[col.field] = "";
          row[col.field] = 0;
          row.__symbols[col.field] = "";
        } else if (typeof rawVal === "number") {
          // numeric from API — format per original rules
          row[col.field] = Math.round(rawVal * 10000) / 10000;
          if (col.field === "SPEND_COUNT_VAL") {
            row.__rawValues[col.field] = this.formatThousandsNoDecimal(rawVal);
          } else {
            const trimmed = this.formatTrimmed(rawVal);
            if (col.type === "percent") row.__rawValues[col.field] = trimmed ? trimmed + "%" : "";
            else if (col.type === "currency") row.__rawValues[col.field] = trimmed ? "$" + trimmed : "";
            else row.__rawValues[col.field] = trimmed;
          }
          row.__symbols[col.field] = ""; // no symbol extracted
        } else {
          // string from API like "¥ 3.000000" or "0.5000 %"
          const { symbol, numeric } = this.extractSymbolAndNumeric(rawVal, col.type);
          row[col.field] = Math.round(numeric * 10000) / 10000;
          row.__symbols[col.field] = symbol || "";

          // build raw display as API-style (prefer using API string format if available)
          const trimmed = this.formatTrimmed(row[col.field]);
          if (col.type === "percent") {
            row.__rawValues[col.field] = trimmed ? trimmed + " %" : "";
            row.__symbols[col.field] = "%";
          } else if (col.type === "currency") {
            row.__rawValues[col.field] = trimmed ? (symbol ? symbol + " " + trimmed : "$" + trimmed) : "";
          } else {
            row.__rawValues[col.field] = trimmed;
            if (!row.__symbols[col.field]) row.__symbols[col.field] = "";
          }
        }
      });

      grouped[header].push(row);
    });
    return grouped;
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.initStateFromProps(this.props.data || []) });
    }
  }

  // determine row availability (same as old)
  isRowAvailable = (row) => {
    const val =
      row.FIELD_AVAILABLE !== undefined
        ? row.FIELD_AVAILABLE
        : row.Field_Available !== undefined
        ? row.Field_Available
        : row.FieldAvailable;
    if (typeof val === "string") return val.toLowerCase() !== "no";
    if (typeof val === "boolean") return !!val;
    return true;
  };

  // --- Input handling: only SAVING_VALUE is editable; input accepts only numeric part
  handleInputChange = (header, rowIdx, field, rawValue) => {
    const data = { ...this.state.data };
    const rows = [...data[header]];
    const row = { ...rows[rowIdx] };
    if (!row.__rawValues) row.__rawValues = {};
    if (!row.__symbols) row.__symbols = {};

    // rawValue should be numeric-only while typing; allow "", "-", ".", "(123)", numbers with up to 4 decimals
    if (this.isValidTypingInput(rawValue)) {
      row.__rawValues[field] = rawValue;
      // update numeric for immediate calculations (but save uses final numeric rounding)
      const candidateForParse = String(rawValue).trim().replace(/[$,%\s\u00A0]/g, "");
      if (candidateForParse === "" || candidateForParse === "-" || candidateForParse === ".") {
        // do not update numeric
      } else {
        row[field] = this.toFourDecimalNumber(rawValue);
      }
    } else {
      // invalid keystroke -> ignore
    }

    rows[rowIdx] = row;
    data[header] = rows;
    this.setState({ data, hasChanges: true,responseMsg: "Pending changes. Click Save to update." });
    this.props.pendingChanges(true);
  };

  handleInputBlur = (header, rowIdx, field, type) => {
    const data = { ...this.state.data };
    const rows = [...data[header]];
    const row = { ...rows[rowIdx] };
    if (!row.__rawValues) row.__rawValues = {};
    if (!row.__symbols) row.__symbols = {};

    const raw = row.__rawValues[field];
    const symbol = row.__symbols[field] || "";

    if (raw === null || raw === undefined || String(raw).trim() === "") {
      row.__rawValues[field] = "";
      row[field] = 0;
    } else {
      if (this.isValidTypingInput(raw)) {
        const num = this.toFourDecimalNumber(raw);
        row[field] = num;
        if (field === "SPEND_COUNT_VAL") {
          row.__rawValues[field] = num ? this.formatThousandsNoDecimal(num) : "";
        } else {
          const trimmed = this.formatTrimmed(num);
          if (type === "percent") {
            row.__rawValues[field] = trimmed ? trimmed + " %" : "";
            row.__symbols[field] = "%";
          } else if (type === "currency") {
            row.__rawValues[field] = trimmed ? (symbol ? symbol + " " + trimmed : "$" + trimmed) : "";
          } else {
            row.__rawValues[field] = trimmed;
          }
        }
      } else {
        // invalid -> reformat to current numeric value
        if (field === "SPEND_COUNT_VAL") {
          row.__rawValues[field] = this.formatThousandsNoDecimal(row[field]);
        } else {
          const formatted = this.formatTrimmed(row[field]);
          if (type === "percent") row.__rawValues[field] = formatted ? formatted + " %" : "";
          else if (type === "currency") row.__rawValues[field] = formatted ? (row.__symbols[field] || "$") + " " + formatted : "";
          else row.__rawValues[field] = formatted;
        }
      }
    }

    rows[rowIdx] = row;
    data[header] = rows;
    this.setState({ data, hasChanges: true });
  };

  // --- Save flow (kept same as your working old version; uses UpdateRiseSavingDashboard sequentially)
  onSave() {
    if (this.state.isSaveInProgress) return;

    const vsObj = this.props.spendDetails && this.props.spendDetails.currentActiveRequest;
    const vsId = vsObj && vsObj.VS_ID;
    const DMC_ID = vsObj && vsObj.DMC_ID;
    const USER_EMAIL = this.props.user && this.props.user.user && this.props.user.user.Email;

    if (!vsId) {
      this.setState({ isError: true, errorMsg: "VS_ID not available", responseMsg: "" });
      return;
    }

    this.setState({ isSaveInProgress: true, responseMsg: "", isError: false, errorMsg: "" });

    try {
      const grouped = this.state.data || {};
      const savedRows = []; // will hold ordered save tasks

      // build ordered list of rows to save (preserves table/row order)
      for (const header of Object.keys(grouped)) {
        const rows = grouped[header] || [];
        for (let r = 0; r < rows.length; r++) {
          const row = rows[r];
          if (!this.isRowAvailable(row)) continue;

          // prefer live raw value for SAVING_VALUE (user may have typed)
          const rawSaving = row.__rawValues && row.__rawValues["SAVING_VALUE"] !== undefined
            ? row.__rawValues["SAVING_VALUE"]
            : null;

          // rawSaving may contain currency symbol or percent. Parse numeric properly.
          const savingVal = rawSaving !== null && String(rawSaving).trim() !== ""
            ? this.toFourDecimalNumber(rawSaving)
            : (typeof row.SAVING_VALUE === "number" ? row.SAVING_VALUE : this.parseNumeric(row.SAVING_VALUE));

          const saving = Math.round(savingVal * 10000) / 10000;

          savedRows.push({
            header,
            rowIndex: r,
            field: "SAVING_VALUE",
            value: saving,
            id: row.SAVING_PARAM_ID || null,
            spendValue: row.SPEND_COUNT_VAL
          });
        }
      }

      if (savedRows.length === 0) {
        this.setState({ responseMsg: "No records to save", hasChanges: false, isSaveInProgress: false });
        this.props.pendingChanges(null);
        return;
      }

      // We'll execute saves sequentially using a promise chain
      const newData = { ...this.state.data }; // we'll mutate and setState progressively
      let chain = Promise.resolve();

      savedRows.forEach((s) => {
        chain = chain.then(() => {
          // call the action (might return a promise or not)
          let result;
          try {
            result = this.props.UpdateRiseSavingDashboard(
              vsId,
              DMC_ID,
              USER_EMAIL,
              // SAVING_TAB_NAME and HEADER_FIELD_NAME must be obtained from row inside newData,
              // because row objects keep SAVING_FIELD_NAME etc.
              (newData[s.header] && newData[s.header][s.rowIndex] && newData[s.header][s.rowIndex].SAVING_FIELD_NAME) || "",
              (newData[s.header] && newData[s.header][s.rowIndex] && newData[s.header][s.rowIndex].HEADER_FIELD_NAME) || s.header || "",
              s.spendValue,
              s.value
            );
          } catch (callErr) {
            // synchronous throw -> return a rejected Promise to break chain
            return Promise.reject(callErr);
          }

          const p = (result && typeof result.then === "function") ? result : Promise.resolve(result);

          // after each save resolves, update local newData and setState so UI shows incremental updates
          return p.then(() => {
            if (!newData[s.header] || !newData[s.header][s.rowIndex]) return;
            const targetRow = { ...newData[s.header][s.rowIndex] };
            targetRow[s.field] = s.value;

            const colDef = (this.columnsMap[s.header] || []).find(c => c.field === s.field);
            if (!targetRow.__rawValues) targetRow.__rawValues = {};
            if (colDef && colDef.type === "percent") {
              // percent must show with " %" as in API
              targetRow.__rawValues[s.field] = this.formatTrimmed(s.value) ? this.formatTrimmed(s.value) + " %" : "";
              targetRow.__symbols = targetRow.__symbols || {};
              targetRow.__symbols[s.field] = "%";
            } else if (colDef && colDef.type === "currency") {
              // preserve the symbol we parsed earlier (targetRow.__symbols)
              targetRow.__symbols = targetRow.__symbols || {};
              const sym = (targetRow.__symbols[s.field] && targetRow.__symbols[s.field].trim()) || "";
              targetRow.__rawValues[s.field] = this.formatTrimmed(s.value) ? (sym ? sym + " " + this.formatTrimmed(s.value) : "$" + this.formatTrimmed(s.value)) : "";
            } else {
              targetRow.__rawValues[s.field] = this.formatTrimmed(s.value);
            }

            newData[s.header][s.rowIndex] = targetRow;
            // update UI incrementally
            this.setState({ data: { ...newData } });
            // chain continues
            return;
          });
        });
      });

      // finalize chain
      chain
        .then(() => {
          // Saved all rows locally — reload full dataset to ensure grid reflects server state.
          // Use full reload (no headersToReload) to avoid header-key mismatches.
          this.props.pendingChanges(null);
          this.setState({ responseMsg: "Saved successfully", hasChanges: false }, () => {
            this.reloadData(); // <-- reload everything to guarantee grid refresh
          });

        })
        .catch((err) => {
          this.setState({
            isError: true,
            errorMsg: err && err.message ? err.message : "Save failed",
            responseMsg: "",
          });
        })
        .then(() => {
          // always clear in-progress flag
          this.setState({ isSaveInProgress: false });
        });
    } catch (err) {
      // synchronous error guard
      this.setState({
        isError: true,
        errorMsg: err && err.message ? err.message : "Save failed",
        responseMsg: "",
        isSaveInProgress: false,
      });
    }
  }

  // reloadData: calls GetRiseSavingDetails if available and updates only the specified headers in local state
 
// Replace existing reloadData(...) with this minimal-change version
reloadData(headersToReload) {
  const vsObj = this.props.spendDetails && this.props.spendDetails.currentActiveRequest;
  const vsId = vsObj && vsObj.VS_ID;
  const DMC_ID = vsObj && vsObj.DMC_ID;
  const USER_EMAIL = this.props.user && this.props.user.user && this.props.user.user.Email;

  if (!vsId) return;

  if (this.props.GetRiseSavingDetails && typeof this.props.GetRiseSavingDetails === "function") {
    try {
      this.setState({ isLoading: true });

      const respOrPromise = this.props.GetRiseSavingDetails(DMC_ID, vsId, USER_EMAIL);

      if (respOrPromise && typeof respOrPromise.then === "function") {
        respOrPromise
          .then((resp) => {
            // locate server table array in common response shapes
            const tableArray =
              (resp && resp.data && resp.data.Result && resp.data.Result.Table) ||
              (resp && resp.data && resp.data.Table) ||
              (resp && resp.Result && resp.Result.Table) ||
              (resp && resp.data && resp.data.Tableesult) || // legacy weird shape
              (Array.isArray(resp) ? resp : null);

            if (!Array.isArray(tableArray)) {
              // No good table array found; stop loading but keep UI as-is
              this.setState({ isLoading: false });
              return;
            }

            // Build grouped map using existing helper
            const serverGrouped = this.initStateFromProps(tableArray);

            // If caller explicitly passed '*' we do full replace (optional feature)
            if (headersToReload === "*") {
              this.setState({ data: serverGrouped, isLoading: false, hasChanges: false });
              return;
            }

            // Determine which headers to update:
            // - If explicit headersToReload array provided -> use it
            // - Otherwise default to only the headers currently present in this.state.data
            const currentKeys = this.state && this.state.data ? Object.keys(this.state.data) : [];
            const headersToUpdate = Array.isArray(headersToReload) && headersToReload.length > 0
              ? headersToReload
              : currentKeys;

            // Merge: update only the requested headers that exist in serverGrouped.
            // If server returns nothing for a header that exists locally, we preserve local (do NOT create new headers).
            const newData = { ...(this.state.data || {}) };

            headersToUpdate.forEach((h) => {
              if (serverGrouped.hasOwnProperty(h)) {
                newData[h] = serverGrouped[h]; // update from server
              } else {
                // server didn't return that header. Keep existing local data instead of clearing or creating new keys.
                // Optionally: if you prefer clearing when server returns nothing, uncomment the next line:
                // newData[h] = [];
              }
            });

            // set state with merged data (only touched headers updated)
            this.setState({ data: newData, isLoading: false, hasChanges: false });
          })
          .catch(() => {
            this.setState({ isLoading: false });
          });
      } else {
        this.setState({ isLoading: false });
      }
    } catch (err) {
      this.setState({ isLoading: false });
    }
  }
}


  // getTotals stays same
  getTotals = (rows, columns) => {
    const totals = {};
    columns.forEach(({ field }) => {
      totals[field] = rows.reduce((sum, row) => {
        return sum + (typeof row[field] === "number" ? row[field] : this.parseNumeric(row[field]));
      }, 0);
    });
    return totals;
  };

  render() {
    const {
      data,
      isLoading,
      isError,
      errorMsg,
      responseMsg,
      isSaveInProgress,
      hasChanges,
    } = this.state;

    return (
      <div className="saving-table">
        <div className="medium-12">
          {isLoading ? (
            <img
              style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
              src={path + `images/ajax-loader.gif`}
              alt=""
            />
          ) : null}

          {isError ? (
            <div style={{ color: "red", textAlign: "center" }} className="cell pt5">
              {errorMsg}
            </div>
          ) : responseMsg ? (
            <div style={{ color: "green", textAlign: "center" }} className="cell pt5">
              {responseMsg}
            </div>
          ) : null}
        </div>

        <div className="medium-12">
          <button
            className={classNames("float-right", "pr25")}
            onClick={this.onSave}
            disabled={!hasChanges || isSaveInProgress}
            title={this.props.ui && this.props.ui.save}
            type="button"
          >
            <img width="20" src={path + `images/save_active.svg`} alt="Save" />
          </button>
        </div>

        {Object.keys(data).map((header) => {
          const rows = data[header] || [];

          const anyAvailable = rows.some((r) => this.isRowAvailable(r));
          if (!anyAvailable) return null;

          const columns = this.columnsMap[header] || [];

          // stable table key
          const tableKey = `table-${header || "no-header"}`;

          return (
            <table key={tableKey}>
              <thead>
                <tr className="header-row">
                  <th colSpan={columns.length}>{header}</th>
                </tr>
                <tr>
                  {columns.map((col, i) => (
                    <th key={col.field || i}>
                      {col.label}
                      {col.type === "percent" ? "" : ""}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, rIdx) => {
                  const rowKey = row.SAVING_PARAM_ID ? `row-${row.SAVING_PARAM_ID}` : `row-${header}-${rIdx}`;
                  return (
                    <tr key={rowKey}>
                      {columns.map((col, cIdx) => {
                        const isEditable = col.field === "SAVING_VALUE";
                        const raw = (row.__rawValues && row.__rawValues[col.field]) || "";
                        const symbol = (row.__symbols && row.__symbols[col.field]) || "";

                        if (!isEditable) {
                          // Format SPEND_COUNT_VAL: use API symbol if available + thousands formatting
                          if (col.field === "SPEND_COUNT_VAL" || cIdx >= 2) {
                            if (col.field === "SPEND_COUNT_VAL") {
                              const numFormatted = this.formatThousandsNoDecimal(row[col.field]);
                              // Use symbol from parsed API if present; else just show number
                              return <td key={cIdx}>{symbol ? symbol + " " + numFormatted : numFormatted}</td>;
                            }
                            // 3rd & 4th columns: dynamic currency symbol + US thousands formatting (no decimals)
                            if (cIdx >= 2) {
                              // prefer the symbol parsed for this field (row.__symbols), else try props.currencySymbols fallback
                              let currencySym = "";
                              if (symbol && String(symbol).trim() !== "") {
                                currencySym = String(symbol).trim();
                              } else if (this.props.currencySymbols) {
                                // allow different shapes for currencySymbols prop:
                                // - a simple string like "$"
                                // - an object { defaultSymbol: "$", USD: "$", INR: "₹", ... }
                                const cs = this.props.currencySymbols;
                                if (typeof cs === "string") {
                                  currencySym = cs;
                                } else if (cs && typeof cs === "object") {
                                  // try common keys
                                  currencySym = cs.defaultSymbol || cs.symbol || "";
                                  // If your row contains a currency code (e.g., row.CURRENCY or row.CCY),
                                  // prefer that mapping: uncomment & adapt the next lines if you have such a field.
                                  // const currencyCode = row.CURRENCY || row.CCY;
                                  // if (currencyCode && cs[currencyCode]) currencySym = cs[currencyCode];
                                }
                              }

                              // finally default to $
                              if (!currencySym) currencySym = "$";

                              // format numeric part with US thousand separators, no decimals
                              const num = this.parseNumeric(row[col.field]);
                              const numFormatted = Number.isFinite(num)
                                ? num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                : "";

                              // preserve any spacing convention (e.g., "HK$" vs "$")
                              const sep = currencySym.endsWith("$") || currencySym.length > 1 ? "" : " ";
                              // if symbol already includes spacing or letters, you may prefer `${currencySym} ${numFormatted}`
                              return <td key={cIdx}>{currencySym + (sep ? " " : "") + numFormatted}</td>;
                            }

                            // fallback: original formatted display (handles percent/currency as before)
                            const display = this.formatWithType(row[col.field], col.type);
                            return <td key={cIdx}>{display}</td>;
                          }
                          // otherwise use the original formatting (4-decimal, percent/currency prefixes)
                          const display = this.formatWithType(row[col.field], col.type);
                          return <td key={cIdx}>{display}</td>;
                        }

                        // Editable cell (SAVING_VALUE): show symbol outside input and numeric inside input
                        const placeholder =
                          col.field === "SPEND_COUNT_VAL"
                            ? this.formatThousandsNoDecimal(row[col.field])
                            : this.formatWithType(row[col.field], col.type);

                        // compute input value: strip known symbol and percent for the input box
                        let inputValue = raw;
                        if (inputValue && symbol) {
                          if (symbol === "%") {
                            inputValue = String(inputValue).replace("%", "").trim();
                          } else {
                            inputValue = String(inputValue).replace(symbol, "").trim();
                          }
                        }
                        inputValue = inputValue ? inputValue.replace(/,/g, "").trim() : "";

                        return (
                          <td key={cIdx}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              {symbol && symbol !== "%" && symbol !== "" && (
                                <span style={{ marginRight: 4 }}>{symbol}</span>
                              )}
                              <input
                                type="text"
                                value={inputValue}
                                placeholder={placeholder}
                                onChange={(e) =>
                                  this.handleInputChange(header, rIdx, col.field, e.target.value)
                                }
                                onBlur={() => {
                                  this.handleInputBlur(header, rIdx, col.field, col.type);
                                }}
                                style={{ width: "100%" }}
                              />
                              {symbol === "%" && <span style={{ marginLeft: 4 }}>%</span>}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ui: state.content.ui,
    userData: state.valueStory,
    user: state.default,
    content: state.content.spendAnalysis.worldMap,
    focusLabel: state.content.spendAnalysis.enablement.focusLabel,
    spendDetails: state.spendDetails,
    currencySymbols: state.content.CurrencySymbols,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetError: (error) => dispatch(resetError(error)),
    defineScopeLoading: (bool) => dispatch(defineScopeLoading(bool)),
    UpdateRiseSavingDashboard: (VS_ID, DMC_ID, USER_EMAIL, SAVING_TAB_NAME, HEADER_FIELD_NAME, SPEND_COUNT_VAL, SAVING_VALUE) =>
      dispatch(UpdateRiseSavingDashboard(VS_ID, DMC_ID, USER_EMAIL, SAVING_TAB_NAME, HEADER_FIELD_NAME, SPEND_COUNT_VAL, SAVING_VALUE)),
    GetRiseSavingDetails: (DMCId, VSId, userEmail) => dispatch(GetRiseSavingDetails(DMCId, VSId, userEmail)),
    pendingChanges: changes => dispatch(pendingChanges(changes)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SavingContainer);
